import requestAction from '../../utils/requestAction'

export const fetchProductSection = (productSectionId: string) =>
  requestAction('PRODUCTSECTION_DETAIL')(`productSections/${productSectionId}`, 'GET')
